import {reactive} from '@vue/composition-api'

export default function (vm) {
  const compositionFileData = reactive({files:[]})

  function preprocessingImageFile(file, doneCallback, erroCallback) {
    const Vue = vm.proxy
    if (compositionFileData.files.length != 1 || compositionFileData.files[0].name != file.name) {
      compositionFileData.files = [file];
    }

    let tokens = file.name.split('.')
    if (tokens.length < 2) {
      erroCallback({color: 'purple', message: "*.jpg, *.png 또는 *.pdf 형식만 지원 가능합니다"});
      compositionFileData.files = []
      return
    }
    let ext = tokens[tokens.length - 1].toLowerCase()
    
    if (ext == 'pdf') {
      Vue.$dialogPdftoImage.show(compositionFileData.files[0], (data) => {
        // console.log(data)
        if (data.success == true && data.file != null) {
          doneCallback(data.file)
        } else {
          erroCallback({color: 'purple', message: "PDF 읽기에 실패하였습니다"});
          compositionFileData.files = []
        }
      })
    } else {
      if (ext != "jpg" && ext != "jpeg" && ext != "png") {
        erroCallback({color: 'purple', message: "*.jpg, *.png 또는 *.pdf 형식만 지원 가능합니다"});
        compositionFileData.files = []
        return
      }

      doneCallback(file)
    }
  }

  return {
    compositionFileData,
    preprocessingImageFile
  }
}
